import {ChangeEvent} from 'react';
import round from './round';
import {Options} from './types';

const changeEventTarget = (e: ChangeEvent<HTMLInputElement>, v: number, options: Options): HTMLInputElement => {
  // The value of an event target needs to be a string
  const value = Number.isFinite(v) ? round(v, options).toString() : '';
  // We have the valueAsNumber prop for numeric values
  // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement
  const valueAsNumber = Number.isFinite(v) ? v : NaN;
  return { 
    ...e.target, 
    value, 
    valueAsNumber,
    name: e.target.name  
  };
};

export default changeEventTarget;
